import TranslatedObject from "shared-src/data/TranslatedObject";

export default class MediaImage {
    constructor(json) {
        /**
         *
         * @type {TranslatedObject}
         */
        this.legende=new TranslatedObject(json.legende);
        /**
         *
         * @type {string}
         */
        this.src=json.src;
    }

    imageUrl(){
        return "les-images/"+this.src;
    }
}